<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasAdd" @click="$router.push('/checkresult/add')">新增</el-button>
      </template>
      <el-form :model="searchForm" ref="searchForm" inline class="global-form-label-width account-form"
        label-width="100px">
        <el-form-item prop="materialName" label="材料名称">
          <el-input v-model="searchForm.materialName" placeholder="请输入材料名称" />
        </el-form-item>
        <el-form-item prop="entryDate" label="进场日期">
          <el-date-picker v-model="searchForm.entryDate" placeholder="请选择进场日期" type="date" clearable format="yyyy-MM-dd"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item prop="productionDate" label="生产日期">
            <el-date-picker v-model="searchForm.productionDate" @change="changeDate" placeholder="请选择生产日期" type="daterange" clearable
              format="yyyy-MM-dd" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item> -->
        <el-form-item prop="plateNumber" label="车牌号">
          <el-input v-model="searchForm.plateNumber" placeholder="请输入车牌号" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border :data="tableData">
        <el-table-column min-width="120" label="区域名称" prop="areaName"></el-table-column>
        <el-table-column min-width="120" label="网格名称" prop="gridName"></el-table-column>
        <el-table-column min-width="120" label="责任部门" prop="deptName"></el-table-column>
        <el-table-column min-width="120" label="检查日期" prop="inspectionDate"></el-table-column>
        <el-table-column min-width="120" label="检查人" prop="inspectorName"></el-table-column>
        <el-table-column min-width="120" label="检查评价" prop="evaluation"></el-table-column>
        <el-table-column width="180" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" @click="$router.push('/checkresult/detail?recordId=' + row.recordId)">详情</el-button>
            <el-button type="text" v-if="hasEdit" @click="$router.push('/checkresult/edit?recordId=' + row.recordId)">编辑</el-button>
            <el-button v-if="hasDel" type="text" @click="deleteRow(row.recordId)" class="del-btn">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>

  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'

export default {
  name: 'CheckResult',
  mixins: [keepAlive],

  data() {
    return {
      tableData: [],
      page: 1,
      total: 0,
      searchForm: {
        xxx: ''
      }
    }
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasAdd() {
      return this.buttonList.includes('add')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    },
    hasDel() {
      return this.buttonList.includes('delete')
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    deleteRow(recordId) {
      this.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.wspb.deleteDataPaSanitationResult, {
          recordId
        }).then(() => {
          this.loadData()
        })
      })
    },
    loadData() {
      this.$axios.get(this.$apis.wspb.selectPaSanitationResultByPage, {
        ...this.searchForm,
        page: this.page,
        size: 10
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.searchForm.resetFields()
      this.onSearch()
    }
  }
}
</script>
<style lang="scss" scoped></style>
